module.exports = __webpack_public_path__ + "img/404.01a7043d.jpg";